<template>
    <div class="beautiful-details">
        <div class="details-container">
            <!-- Job Type -->
            <div class="detail-chip">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M20 7L10 17l-5-5"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('job_type') }}</span>
                    <span class="chip-value">{{ data.job_type.name }}</span>
                </div>
            </div>

            <!-- Vacancy -->
            <div class="detail-chip">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                        <circle cx="9" cy="7" r="4"/>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('vacancy') }}</span>
                    <span class="chip-value">{{ data.vacancy_count }}</span>
                </div>
            </div>

            <!-- Department -->
            <div class="detail-chip">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M3 3h18v18H3zM21 9H3M21 15H3M12 3v18"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('department') }}</span>
                    <span class="chip-value">{{ data.department.name }}</span>
                </div>
            </div>

            <!-- Salary -->
            <div class="detail-chip" v-if="Boolean(+data.is_viewable) && data.salary">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('salary') }}</span>
                    <span class="chip-value">{{ data.salary }}</span>
                </div>
            </div>

            <!-- Working Arrangement -->
            <div class="detail-chip">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('working_arrangement') }}</span>
                    <span class="chip-value">{{ $t(data.working_arrangement) }}</span>
                </div>
            </div>

            <!-- Experience Level -->
            <div class="detail-chip" v-if="Boolean(+data.is_viewable)">
                <div class="chip-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                </div>
                <div class="chip-content">
                    <span class="chip-label">{{ $t('experience_level') }}</span>
                    <span class="chip-value">{{ $t(data.experience_level.name) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
            required: true
        },
        detailsStyle: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        activePreview: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
.beautiful-details {
    margin: 1.5rem 0;
}

.details-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    padding: 0.5rem;
}

.detail-chip {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 1rem 1.25rem;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border-color: #cbd5e1;
    }
}

.chip-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f4751f 0%, #e86411 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(244, 117, 31, 0.3);
    
    svg {
        width: 16px;
        height: 16px;
        stroke-width: 2.5;
    }
}

.chip-content {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex: 1;
    min-width: 0;
}

.chip-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    line-height: 1;
}

.chip-value {
    font-size: 0.9375rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

// Responsive Design
@media (max-width: 1024px) {
    .details-container {
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 0.875rem;
    }
    
    .detail-chip {
        padding: 0.875rem 1rem;
        gap: 0.75rem;
    }
    
    .chip-icon {
        width: 32px;
        height: 32px;
        border-radius: 8px;
        
        svg {
            width: 14px;
            height: 14px;
        }
    }
}

@media (max-width: 768px) {
    .beautiful-details {
        margin: 1.25rem 0;
    }
    
    .details-container {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.75rem;
        padding: 0.25rem;
    }
    
    .detail-chip {
        padding: 1rem;
        gap: 0.75rem;
        border-radius: 10px;
    }
    
    .chip-icon {
        width: 34px;
        height: 34px;
        border-radius: 8px;
        
        svg {
            width: 15px;
            height: 15px;
        }
    }
    
    .chip-label {
        font-size: 0.8125rem;
    }
    
    .chip-value {
        font-size: 1rem;
    }
}

@media (max-width: 640px) {
    .details-container {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
    
    .detail-chip {
        padding: 1.125rem 1.25rem;
        gap: 1rem;
        border-radius: 12px;
    }
    
    .chip-icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        
        svg {
            width: 17px;
            height: 17px;
        }
    }
    
    .chip-label {
        font-size: 0.875rem;
    }
    
    .chip-value {
        font-size: 1.0625rem;
        font-weight: 600;
    }
}

@media (max-width: 480px) {
    .beautiful-details {
        margin: 1rem 0;
    }
    
    .details-container {
        gap: 0.625rem;
        padding: 0;
    }
    
    .detail-chip {
        padding: 1.25rem 1.5rem;
        gap: 1rem;
        border-radius: 14px;
    }
    
    .chip-icon {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        
        svg {
            width: 18px;
            height: 18px;
        }
    }
    
    .chip-label {
        font-size: 0.9375rem;
    }
    
    .chip-value {
        font-size: 1.125rem;
        font-weight: 700;
    }
}
</style>

